<script>
import Layout from '@layouts/main'
import GroupPanel from '@components/group/panel'
import GroupLinks from '@components/group/links'
import NewContent from '@components/content'
import ListFeed from '@components/feed/list'
export default {
  page: {
    title: 'MAIN FEED',
    meta: [
      {
        name: 'description',
      },
    ],
  },
  components: {
    Layout,
    GroupPanel,
    GroupLinks,
    NewContent,
    ListFeed,
  },
  data: () => ({
    name: null,
  }),
  computed: {},
}
</script>

<template>
  <Layout>
    <div>
      <GroupPanel class="groups" />
      <GroupLinks />
      <NewContent />
      <ListFeed />
    </div>
  </Layout>
</template>
